import './index.css';
import { getTeamA, getTeamB, isMatchInScheduled } from '../../../utilities/helper';
import { customizeLeagueTitle } from '../../../utilities/MatchTitleFormat';
import { Image, CountdownTimer, View, Text, Card } from '../../../component';
import React from 'react';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
import { showToast } from '../../../actions/app-actions-types';
import { useDispatch } from 'react-redux';
import constants from '../../../constants';
interface CounterWrapperProps {
  matchStatus?: number;
  onCalledDeadline?: React.MouseEventHandler;
  screen?: string;
  verified?: string;
  theme?: any;
  matchItem?: object;
  isScheduled?: boolean;
  gameType?: string;
}
const CounterWrapper = ({
  matchStatus,
  onCalledDeadline,
  screen,
  verified,
  theme,
  matchItem,
  isScheduled,
  gameType
}: CounterWrapperProps) => {
  const counterTitle = {
    backgroundColor: theme.fixtureMatchItemTimeOut,
    color: theme.fixtureMatchItemTimeOutText
  };

  return (
    <View className="counter_wrapper">
      {isScheduled ? (
        <CountdownTimer
          onCalledDeadline={onCalledDeadline}
          screen={screen}
          matchItem={matchItem}
          style={counterTitle}
          isShowAlert={false}
          gameType={gameType}
        />
      ) : matchStatus === 2 && verified ? (
        <Text className="counter_title" style={{ ...counterTitle, fontWeight: 500 }}>
          {I18n.t('Completed')}
        </Text>
      ) : matchStatus === 2 ? (
        <Text className="counter_title" style={counterTitle}>
          {I18n.t('Reviewed')}
        </Text>
      ) : matchStatus === 3 ? (
        <Text className="counter_title" style={{ ...counterTitle, color: '#ffd500' }}>
          {'LIVE'}
        </Text>
      ) : (
        <Text className="counter_title" style={counterTitle}>
          {'Abandoned'}
        </Text>
      )}
    </View>
  );
};

const MatchCard = ({ onPressMatchCard, matchItem = {}, gameType = '', tabType = '' }: any) => {
  const { FantasyTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const {
    status: matchStatus,
    verified,
    preSquad = false,
    gameState = 0,
    description = {},
    lineupsOut = false,
    substitutionStatus = '',
    matchTeamLock = '',
    matchTeamLockTime = '',
    matchDelayed = false,
    adminVerified = false,

    statusText
  } = matchItem;
  const matchVerified = gameType === Constants.GameType.FANTASY_YES_NO ? adminVerified : verified;
  const { short = 'Win from Thousands' } = description;
  const teamA = getTeamA(matchItem, gameType) || {};
  const teamB = getTeamB(matchItem, gameType) || {};
  const matchTitle = customizeLeagueTitle(matchItem);

  const isScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const substitutionStatusMsg =
    matchTeamLockTime && !matchTeamLock
      ? 'substitution window closing soon'
      : substitutionStatus === 'SUBSTITUTED' && matchTeamLock
      ? 'substitutions completed'
      : 'substitution window open';
  const onCalledDeadline = () => {};

  // const container = {
  //   backgroundColor: theme.fixtureMatchItemBG,
  //   borderColor: theme.fixtureMatchItemBorder
  // };

  const shortDesc = {
    color: theme.fixtureMatchShortTitle
  };

  const footer = {
    backgroundColor: theme.fixtureMatchFooterBG
  };
  const _onPressMatchCard = (e: any) => {
    e.stopPropagation();
    if (preSquad) {
      onPressMatchCard({
        ...matchItem,
        teamA,
        teamB,
        matchTitle
      });
    } else dispatch(showToast('squad not out'));
  };
  const getStatusText = () => {
    if (
      gameType === constants.GameType.FANTASY_CRICKET ||
      gameType === constants.GameType.FANTASY_YES_NO
    ) {
      return statusText === 'Live' ? 'Contests' : statusText === 'Completed' ? 'Results' : 'Play';
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      return statusText == 'live' ? 'Contests' : statusText == 'result' ? 'Results' : 'Play';
    }
  };
  const matchCardContestDetailsSection = {
    background: theme.matchCardContestDetailsBg,
    boxShadow: theme.matchCardContestDetailsBoxShadow
  };
  const matchCardStyle = {
    border: `2px solid ${theme.matchCardBorder}`
  };
  const matchCardTeamFlagContainerStyle = {
    background: theme.matchCardTeamFlagContainerBg,
    boxShadow: theme.matchCardTeamFlagContainerBoxShadow,
    borderRight: `2px solid ${theme.matchCardBorder}`
  };
  const matchCardActionBtnContainerStyle = {
    background: theme.matchCardActionBtnContainerbg,
    boxShadow: theme.matchCardActionBtnContainerBoxShadow,
    borderLeft: `2px solid ${theme.matchCardBorder}`
  };

  const matchCardPlayBtnStyle = {
    background: theme.matchCardPlayBtnBg,
    boxShadow: theme.matchCardPlayBtnBoxShadow,
    border: `1px solid ${theme.matchCardPlayBtnBorder}`
  };
  return (
    <>
      <Card onPress={_onPressMatchCard} className="match_card_container" style={matchCardStyle}>
        <div className="teams_img_container" style={matchCardTeamFlagContainerStyle}>
          <View className="match_card_teams_img">
            <Image
              source={`${teamA?.logoURL}`}
              placeHolderType={'Match'}
              style={{
                width: '90%',
                height: '100%'
              }}
            />
          </View>
          <View className="match_card_versus_text">VS</View>

          <View className="match_card_teams_img">
            <Image
              source={`${teamB?.logoURL}`}
              placeHolderType={'Match'}
              style={{
                width: '90%',
                height: '100%'
              }}
            />
            <View></View>
          </View>
        </div>
        <div className="match_card_team_details_container" style={matchCardContestDetailsSection}>
          <div className="match_card_team_title">
            <div style={{ textTransform: 'uppercase' }}>{` ${teamA.name} vs ${teamB.name}`} </div>{' '}
            {isScheduled && (
              <View style={{ paddingLeft: '10px' }}>
                {lineupsOut && (
                  <Text className="match_card_lineup_out" style={{ color: '#04c33b' }}>
                    {I18n.t('LineupOut')}
                  </Text>
                )}
              </View>
            )}
            {tabType === 'LIVE' &&
              substitutionStatusMsg &&
              gameType == Constants.GameType.FANTASY_SUBSTITUTION && (
                <View style={footer} className="match_card_footer">
                  <Text style={shortDesc} className="match_card_substitution_msg">
                    {substitutionStatusMsg}
                  </Text>
                </View>
              )}
          </div>

          <div className="match_card_title_container"> {`${customizeLeagueTitle(matchItem)}`}</div>
          <div className="match_card_footer">
            {isScheduled && (
              <div>
                <Text style={shortDesc} className="match_card_short_desc">
                  {short}
                </Text>
              </div>
            )}
            <div
              className="counter_container"
              style={{
                backgroundColor: isScheduled ? theme.matchCardTimerBg : '',
                padding: isScheduled ? '5px' : '',
                borderRadius: '5px'
              }}>
              {isScheduled && <Constants.Svgs.Timer width={'20px'} height={'15px'} />}
              <CounterWrapper
                onCalledDeadline={onCalledDeadline}
                screen={''}
                matchStatus={matchStatus}
                verified={matchVerified}
                theme={theme}
                matchItem={matchItem}
                isScheduled={isScheduled}
                gameType={gameType}
              />
            </div>
          </div>
        </div>
        <div className="match_card_play_btn_container" style={matchCardActionBtnContainerStyle}>
          {
            <button
              className="match_card_play_btn"
              onClick={_onPressMatchCard}
              style={matchCardPlayBtnStyle}>
              {getStatusText()}
            </button>
          }
        </div>
      </Card>
    </>
  );
};
export default React.memo(MatchCard);
